import React, { useState } from "react";
import { navigate } from "@reach/router";
import { withStyles } from "@material-ui/core/styles";
import { API } from "aws-amplify";
import { Formik } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import { MenuItem } from "@material-ui/core";
import Snackbar from "../../../../components/Snackbar";
import {
  extractGoogleSheetId,
  messagefnSwitcher,
  messageSwitcher
} from "../../../../utils/formHelper";
import Loader from "../../Loader";

const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fefefe",
    width: 500
  },
  formElement: {
    margin: theme.spacing.unit
  }
});

const renderMessage = (message, messageFunc, variant) => {
  if (!message) {
    return "";
  }
  return (
    <Snackbar
      message={message}
      onClose={() => messageFunc(null)}
      open={Boolean(message)}
      variant={variant}
    />
  );
};

const ImportForm = ({ classes, survey, jwtToken }) => {
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const modeValues = ["content", "logic", "committee"];
  const DEFAULT_LOCALE = "en";
  const message = "importing";
  const [successMessage, setSuccessMessage] = useState(null);
  const createOrUpdate = async data => {
    setLoader(true);
    try {
      await API.put(
        "surveys",
        `/surveys/${survey._id}/importer/locale/${data.locale}`,
        {
          body: {
            ...data
          },
          headers: { Authorization: `Bearer ${jwtToken}` }
        }
      );
      setLoader(false);
      setSuccessMessage("imported survey successfully");
      navigate(`/admin/surveys/${survey.name}`);
    } catch (error) {
      setLoader(false);
      setErrorMessage(error.message);
    }
  };

  return (
    <>
      <Loader loader={loader} message={message} />

      <Formik
        enableReinitialize
        initialValues={{
          mode: modeValues[0],
          googleSheetId: extractGoogleSheetId(survey),
          locale: DEFAULT_LOCALE
        }}
        validationSchema={Yup.object().shape({
          googleSheetId: Yup.string().required("google Sheet id required"),
          mode: Yup.string().required("mode is required"),
          locale: Yup.string().required("locale is required")
        })}
        onSubmit={values => createOrUpdate(values)}
        render={({ values, handleChange, errors, handleSubmit }) => (
          <form className={classes.container} noValidate autoComplete="off">
            <TextField
              name="mode"
              label="mode"
              select={true}
              value={values.mode}
              onChange={handleChange}
              helperText={errors.mode}
              margin="normal"
              className={classes.formElement}
              InputLabelProps={{
                shrink: true
              }}
            >
              {modeValues.map((type_, idx) => (
                <MenuItem key={idx} value={type_}>
                  {type_}
                </MenuItem>
              ))}
            </TextField>

            <Button
              variant="contained"
              color="primary"
              className={classes.formElement}
              onClick={handleSubmit}
            >
              import
            </Button>
          </form>
        )}
      />
      {renderMessage(
        errorMessage || successMessage,
        messagefnSwitcher(
          errorMessage,
          successMessage,
          setErrorMessage,
          setSuccessMessage
        ),
        messageSwitcher(errorMessage)
      )}
    </>
  );
};

export default withStyles(styles)(ImportForm);
